// Studyo Today Backend
// Package studyo.today.users.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/users/v1/resources/user_profile.proto (package studyo.today.users.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_studyo_today_users_v1_resources_user_persona } from "./user_persona_pb.js";

/**
 * Describes the file studyo/today/users/v1/resources/user_profile.proto.
 */
export const file_studyo_today_users_v1_resources_user_profile = /*@__PURE__*/
  fileDesc("CjJzdHVkeW8vdG9kYXkvdXNlcnMvdjEvcmVzb3VyY2VzL3VzZXJfcHJvZmlsZS5wcm90bxIfc3R1ZHlvLnRvZGF5LnVzZXJzLnYxLnJlc291cmNlcyLXAgoLVXNlclByb2ZpbGUSDwoHdXNlcl9pZBgBIAEoCRITCgtmaXJlYmFzZV9pZBgCIAEoCRIwCgxjcmVhdGVkX3RpbWUYAyABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEjIKDmxhc3Rfc2Vlbl90aW1lGAQgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIRCglmdWxsX25hbWUYBSABKAkSFQoNZW1haWxfYWRkcmVzcxgGIAEoCRIZChFpc19lbWFpbF92ZXJpZmllZBgHIAEoCBITCgtwaWN0dXJlX3VybBgIIAEoCRI9CgdwZXJzb25hGAkgASgOMiwuc3R1ZHlvLnRvZGF5LnVzZXJzLnYxLnJlc291cmNlcy5Vc2VyUGVyc29uYRIUCgxjdWx0dXJlX25hbWUYCiABKAkSDQoFcm9sZXMYCyADKAlCJ6oCJFN0dWR5by5Ub2RheS5Vc2Vycy5HcnBjLlYxLlJlc291cmNlc2IGcHJvdG8z", [file_google_protobuf_timestamp, file_studyo_today_users_v1_resources_user_persona]);

/**
 * Describes the message studyo.today.users.v1.resources.UserProfile.
 * Use `create(UserProfileSchema)` to create a new message.
 */
export const UserProfileSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_users_v1_resources_user_profile, 0);

